import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import jwtEncode from "jwt-encode";
import LottiePlayer from "lottie-react";
import noDataFound from "../Assets/animationIcons/noDataFound.json";
import { useSelector } from "react-redux";
import { AllUserIcon, SearchesCIcon, StarIcon, ViewEye } from "../Assets/iconshere";
import logo from "../Assets/images/logo.png";
import bgVideo from "../Assets/images/bg-video.mp4";
import apiClient from "../apiClient";
import { PUBLIC_ENVIRONMENT_LIST } from "../apiClient/apiEndpoints";
import { formatNumber } from "../utils/validation";

const HomePage = () => {
  const navigate = useNavigate();
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  let bannerConfig = configData?.landingConfig?.banner;
  let exploreConfig = configData?.landingConfig?.explore;
  const isLoggedIn = userData.token.length > 0 ? true : false;
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);

  const getPublicEnvironmentList = async () => {
    try {
      setLoading(true);
      let data = await apiClient.get(`${configData.config.API_URL}${PUBLIC_ENVIRONMENT_LIST}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
          "Content-Type": "application/json",
        },
      });

      setList(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPublicEnvironmentList();
  }, [isLoggedIn]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let filterList = list.filter((item) => item.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="homepage">
      <div className="home-video">
        {/* {bannerConfig?.background && <img className="homevideo" src={bannerConfig?.background} autoPlay loop muted />} */}
        <video className="homevideo" src={bgVideo} autoPlay loop muted playsInline />
        <div className="detail-info">
          <h5>{bannerConfig?.title || ""}</h5>
          <div className="des">
            <h6>{bannerConfig?.subTitle || ""}</h6>
            <p>{bannerConfig?.text || ""}</p>
            <div className="btn-info">
              <button className="gotodash" onClick={() => navigate("/play/5864e448-18f7-4d8c-8da7-59855ce9360c")}>
                Play Now
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="module-boxes">
        <div className="titlensearch pb-5">
          <div className="details">
            <h6 className="title"> {exploreConfig?.title || ""} </h6>
            <p> {exploreConfig?.subTitle || ""} </p>
          </div>
          <form className=" app-search app-search1">
            <div className="position-relative">
              <SearchesCIcon />
              <input
                type="text"
                value={search}
                name="searchName"
                className="form-control"
                placeholder="Search"
                autoComplete="off"
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </form>
        </div>
        <div className="modulelist for-env">
          {loading ? (
            <div className="loading-courses">
              {/* <div className='load-parent'>
                                <div className='load-avatar'>
                                    <svg viewBox="25 25 50 50">
                                        <circle r="20" cy="50" cx="50"></circle>
                                    </svg>
                                </div>
                            </div> */}
              <div className="text-center no-data-found">
                <LottiePlayer animationData={noDataFound} style={{ height: 180 }} autoplay loop />
                <h5>Data fetching</h5>
              </div>
            </div>
          ) : filterList.length > 0 ? (
            <div className="course-tiles">
              {filterList.map((item, index) => {
                return (
                  <div key={item.uuid} className="tilecard env" onClick={() => navigate(`/play/${item.uuid}`)}>
                    <div className="modulecard module" style={{ cursor: "pointer" }}>
                      <div className="cursor-pointer">
                        <div className="moduleleft d-block">
                          <div className="moduleicon">
                            {(Number(item.session) > 0 || Number(item.review) > 0) && (
                              <div className="view-number">
                                {Number(item.session) > 0 && (
                                  <span>
                                    <ViewEye /> <p> {formatNumber(item.session)} </p>{" "}
                                  </span>
                                )}
                                {Number(item.session) > 0 && Number(item.review) > 0 && "|"}
                                {Number(item.review) > 0 && (
                                  <span className="star-rev">
                                    {" "}
                                    <p> {formatNumber(item.review)} </p> <StarIcon />{" "}
                                  </span>
                                )}
                              </div>
                            )}
                            <img
                              src={item?.thumbnail || logo}
                              onError={(e) => {
                                e.target.src = logo;
                                e.onerror = null;
                              }}
                              className="defaultimg"
                              alt={item.name}
                              referrerPolicy={"no-referrer"}
                            />
                          </div>
                          <div className="moduledata">
                            <div className="detailtags userlistnumber pb-0" style={{ justifyContent: "center" }}>
                              <span className="me-1">
                                {" "}
                                <AllUserIcon />{" "}
                              </span>
                              <span> {item.maxUsers} Users allowed </span>
                            </div>
                            <p className="modulename"> {item.name}</p>

                            <p className="moduledes"> {item.description} </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="loading-courses">
              {/* <div className='load-parent'>
                                <div className='load-avatar'>
                                    <svg viewBox="25 25 50 50">
                                        <circle r="20" cy="50" cx="50"></circle>
                                    </svg>
                                </div>
                            </div> */}
              <div className="text-center no-data-found">
                <LottiePlayer animationData={noDataFound} style={{ height: 180 }} autoplay loop />
                <h5>No Result found</h5>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomePage;
